import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Select } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder'
import Button from 'react-bootstrap/esm/Button';

const ReporteDetalladoPeriodo = _ => {
    const [ready, setReady] = useState(false)
    const [isProcessing, setIsProccesing] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')
    const [rows, setRows] = useState([])
    const [period, setPeriod] = useState([])
    const [reporte, setReport] = useState({})

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true)
        })
    }, [])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.report.get_reporte_detallado_periodo({
            p_id_period: periodSelected,
        }).then(res => {
            setRows(res.data.data)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Nombres' },
                { name: 'name_plan', text: 'Rango' },
                { name: 'qty_activos', text: 'Activos', align: 'center' },
                { name: 'qty_calificados', text: 'Calificados', align: 'center' },
                { name: 'qty_rangos', text: 'Rangos', align: 'center' },
                { name: 'point_group', text: 'Puntos Grupales', align: 'center' },
                { name: 'rangos_bronce', text: 'Bronce', align: 'center' },
                { name: 'rangos_plata', text: 'Plata', align: 'center' },
                { name: 'rangos_oro', text: 'Oro', align: 'center' },
                { name: 'rangos_diamante', text: 'Diamante', align: 'center' },
                { name: 'rangos_doble_diamante', text: 'Doble Diamante', align: 'center' },
                { name: 'triple_diamante', text: 'Triple Diamante', align: 'center' },
                { name: 'rangos_diamante_sirius', text: 'Diamante Sirius', align: 'center' },
                { name: 'rangos_diamante_azul', text: 'Diamante Azul', align: 'center' },
                { name: 'qty_inscritos', text: 'Inscritos', align: 'center' },
                { name: 'qty_inscritos_elevate', text: 'Elévate', align: 'center' },
                { name: 'last_date_registration_text', text: 'Notas', align: 'center' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Reporte Detallado Periodo</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false}>
                        <Select
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => setPeriodSelected(e.value)}
                            append={[
                                <Button onClick={handleSubmit}>
                                    <i className="fa fa-search"></i>
                                </Button>
                            ]}
                        />
                    </FormCustom>
                    {reporte?.filename ? <div className='mb-4'>
                        <a href={reporte?.excel} download={reporte?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : ''}
                    {dtRows}
                </Card.Body>
            </Card>
            {/* isProcessing ? '' : <div className="d-flex justify-content-center mt-4">
                <div className="alert alert-success text-center">
                    <h5>Total de Comisiones</h5>
                    {moneyList()}
                </div>
            </div> */}
        </ReactPlaceholder>
    </>
}

export default ReporteDetalladoPeriodo